import { useEffect, useState, useCallback, useRef } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'; // Pour simuler useRoute
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { v4 as uuidv4 } from 'uuid';
import { createAgendaPunch } from '../HomeScreen/queries';
import { CreateAgendaPunchMutation, CreateAgendaPunchMutationVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables } from '../../graphql/API';
import { useAuthContext } from '../../contexts/AuthContext';
import { FaMapLocationDot } from 'react-icons/fa6';
import Sidebar from '../services/Sidebar/Sidebar';
import { getAgendaUser } from '../UserScreen/queries';
import { Spinner } from 'react-bootstrap';
import { MdCenterFocusStrong } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

// Extend Window interface to declare 
// onTokenReceived, onNativeNotificationReceived & onNativeNotificationLinkReceived
// with webkit & chrome for platform detection
declare global {
  interface Window {
    onTokenReceived?: (token: string) => void;
    onNativeNotificationReceived?: (data: any) => void;
    onNativeNotificationLinkReceived?: (data: any) => void;
    onNativeLocationResult?: (data: any) => void;
    bridgeNotificationAsync?: {
      requestNativeLocation: () => void;
    };
    webkit?: {
      messageHandlers?: any;
    };
  }
}
const isWindowApp = navigator.userAgent.includes("SchedulumWinApp");

const isMacOSApp = window.webkit?.messageHandlers?.callbackHandler;
// Geolocation.setRNConfiguration(config);
// Geolocation.getCurrentPosition(info => console.log("GPS", info));
const containerStyle = {
    // width: '100%',
    // height: '100vh'
    marginTop: '3%',
    overflow: 'hidden', 
    width: '90%', 
    height: '95%', 
    borderRadius: 600, 
    alignSelf: 'center',
    backgroundColor: 'white',
    elevation: 10, // Ombre sur Android
    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.25)',
};
  
const defaultCenter = {
    lat: 37.78825,
    lng: -122.4324
};
  
const MapScreen = () => {
    // AUTH
    const {userId: AuthUserId} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    // const savedLang = Cookies.get('language');
    // const [locale, setLocale] = useState("en");
    // NAVIGATION
    const location = useLocation();
    const navigate = useNavigate();
    // PARAMS
    const { id } = useParams<{ id: string }>();
    // MAPS
    const mapRef = useRef<google.maps.Map | null>(null);
    const [center, setCenter] = useState(defaultCenter);
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyAd6WaR-ymbuwFFX51p5SXUK8UBOCK5M90' // Remplace par ta clé API
    });

    // const [region, setRegion] = useState({
    //     latitude: 37.78825, // Valeur par défaut (San Francisco)
    //     longitude: -122.4324,
    //     latitudeDelta: 0.05, // Ajuster le zoom
    //     longitudeDelta: 0.05,
    // });

    const {data: data, loading, error, refetch, fetchMore} = useQuery
        <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
          {variables: {userId: AuthUserId}});

    const [doCreatePunch, {loading: loadingPunch, error: errorPunch}] = 
        useMutation<CreateAgendaPunchMutation, CreateAgendaPunchMutationVariables>(createAgendaPunch);

    const user = data?.getAgendaUser;

    useEffect(() => {
        if (isMacOSApp) {
            
            window.onNativeLocationResult = (data) => {
                if (data.status === 'granted') {
                    const newPos = { lat: data.lat, lng: data.lon };
                    setCenter(newPos);
                    mapRef.current?.panTo(newPos);
                }
            };

            window.webkit.messageHandlers.callbackHandler.postMessage({ action: "requestNativeLocation" });
            // Nettoyage
            return () => { delete window.onNativeLocationResult; };
        } else if (isWindowApp){
            window.onNativeLocationResult = (data) => {
                if (data.status === 'granted') {
                    const newPos = { lat: data.lat, lng: data.lon };
                    setCenter(newPos);
                    mapRef.current?.panTo(newPos);
                }
            };
            window.bridgeNotificationAsync.requestNativeLocation();
        } else {
            navigator.geolocation.getCurrentPosition((info) => {
            setCenter({
                lat: info.coords.latitude,
                lng: info.coords.longitude,
              });
            // setRegion({
            //     latitude: info.coords.latitude,
            //     longitude: info.coords.longitude,
            //     latitudeDelta: 0.0922,
            //     longitudeDelta: 0.0421,
            // }),
            // (error: any) => console.log("Erreur localisation :", error),
            // { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
            });
        }
    }, []);

    useEffect(() => {
        console.log('ERROR', errorPunch?.message || "no error");
    }, [errorPunch]);

    // if (errorPunch) {
    //     return (
    //         <p>Error</p>
    //     )
    // }
    // const onMapClick = useCallback((e: google.maps.MapMouseEvent) => {
    //     if (e.latLng) {
    //       setCenter({
    //         lat: e.latLng.lat(),
    //         lng: e.latLng.lng()
    //       });
    //     }
    // }, []);
    if (!user) {
       return (
            <div className="spinnerContainer">
                {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
                <Spinner animation="border" role="status" className="spinner">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>   
            </div>
        )
    };

    if (errorPunch) return <p>❌ Une erreur est survenue : {errorPunch.message}</p>;

    if (!isLoaded) return <p>Chargement de la carte...</p>;

    // const onRegionChange = (region: any) => {
    //     setCenter(region);
    // }

    // const generateCustomId = () => {
    //     const prefix = "Punch";
    //     const uniquePart = uuidv4();
    //     return `${prefix}-${uniquePart}`;
    // };
    const generateCustomId = () => `Punch-${uuidv4()}`;

    const buildPunch = async (position: any) => {
        try {
            await doCreatePunch({variables: {input: {
                punchId: generateCustomId(),
                userId: AuthUserId,
                createdAt: new Date().toISOString(),
                shiftId: id, //user.shifts[0].shiftId
                startAt: new Date().toISOString(),
                stopAt: new Date().toISOString(),
                deleted: false,
                accuracy: position?.coords?.accuracy?.toString() || "",
                heading: position?.coords?.heading?.toString() || "",
                altitude: position?.coords?.altitude?.toString() || "",
                latitude: position?.coords.latitude.toString() || "",
                longitude: position?.coords.longitude.toString() || "",
                speed: position?.coords?.speed?.toString() || "",
                timestamp: position.timestamp.toString() || "",
                updatedAt: new Date().toISOString(),
            }}});
            navigate(t('link.dashboard'), { state: { status: "bg-success", title: t('punch.punchSaveTitle'), toastMessage: t('punch.punchSaveMessage'), toastUsername: true }});
        } catch (error) {
            console.log((error as Error).message);
            navigate(t('link.dashboard'), { 
                replace: true, 
                state: { status: "bg-danger", title: t('punch.punchSaveErrorTitle'), toastMessage: t('punch.punchSaveErrorMessage') }
            });
        }
    }
    
    const savePunch = async () => {
        // setPunchColor("#CCC");
        // if (currentShift) {
        try {
            // let position: any;
            if (isMacOSApp) {
                const position: any = await new Promise((resolve, reject) => {
                    window.onNativeLocationResult = (data) => {
                        if (data.status === 'granted') {
                            resolve({
                                coords: {
                                    latitude: data.lat,
                                    longitude: data.lon,
                                    accuracy: data.accuracy || "0",
                                    heading: data.heading || null,
                                    altitude: data.altitude || null,
                                    speed: data.speed || null
                                },
                                timestamp: Date.now()
                            });
                        } else {
                            reject(new Error("Localisation native refusée ou erreur."));
                        }
                        // Clean up
                        delete window.onNativeLocationResult;
                    };

                    window.webkit.messageHandlers.callbackHandler.postMessage({ 
                        action: "requestNativeLocation" 
                    });

                    setTimeout(() => reject(new Error("Timeout localisation native")), 8000);
                });
                await buildPunch(position);
            } else if (isWindowApp) {
                const position: any = await new Promise((resolve, reject) => {
                    window.onNativeLocationResult = (data) => {
                        if (data.status === 'granted') {
                            resolve({
                                coords: {
                                    latitude: data.lat,
                                    longitude: data.lon,
                                    accuracy: data.accuracy || "0",
                                    heading: data.heading || null,
                                    altitude: data.altitude || null,
                                    speed: data.speed || null
                                },
                                timestamp: Date.now()
                            });
                        } else {
                            reject(new Error("Localisation native refusée ou erreur."));
                        }
                        // Clean up
                        delete window.onNativeLocationResult;
                    };

                    window.bridgeNotificationAsync.requestNativeLocation();

                    setTimeout(() => reject(new Error("Timeout localisation native")), 8000);
                });
                await buildPunch(position); 
            } else {
                const position = await new Promise<GeolocationPosition>((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject);
                });
                await buildPunch(position);
            }
        } catch (error) {
            console.log((error as Error).message);
            navigate(t('link.dashboard'), { 
                replace: true, 
                state: { status: "bg-danger", title: t('punch.punchSaveErrorTitle'), toastMessage: t('punch.punchSaveErrorMessage') }
            });
        }
    }
    // console.log('REGION', region);
    const onLoad = (map: google.maps.Map) => {
        mapRef.current = map;
    };

    return (
        <div className="d-flex">
            <Sidebar user={user} />
            <div className="users-container flex-grow-1 p-3">
                <div style={{ position: 'relative', height: '100vh', width: '100%', justifyItems: 'center' }}>
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={center}
                        zoom={17}
                        // onClick={onMapClick}
                        onLoad={onLoad}
                        options={{ streetViewControl: false, mapTypeControl: false }}
                    >
                        <Marker position={center} />
                    </GoogleMap>
                    
                    <Link to={{}} onClick={savePunch} style={{textDecoration: 'none'}}>
                        <FaMapLocationDot name="location" size={60} title="Punch" color="white" style={{backgroundColor: '#007bff', 
                            position: 'absolute',
                            bottom: 20,
                            right: 20,
                            height: 80,
                            width: 80,
                            padding:10, 
                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                            borderRadius: 100}}/>
                    </Link>
                    <MdCenterFocusStrong size={60} title="center" color="white"
                        onClick={() => {
                            navigator.geolocation.getCurrentPosition((info) => {
                            const newCenter = {
                                lat: info.coords.latitude,
                                lng: info.coords.longitude,
                            };
                            setCenter(newCenter);
                            mapRef.current?.panTo(newCenter);
                            });
                        }}
                        style={{
                            position: 'absolute',
                            bottom: 20, // un peu plus haut que l'autre bouton
                            left: 20,
                            backgroundColor: '#28a745',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                            height: 80,
                            width: 80,
                            padding:10, 
                            borderRadius: 100
                        }}
                        />
                </div>
            </div>
        </div>
    );
}

export default MapScreen;

